import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { initialFilterForm } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { getFilterCount } from "../../../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { bulkPayModeUploadDropdown, initialForm } from "./constant";
import { updateRequest } from "views/pages/manage/edpOps/constant/common";

const FilterForm = ({
  dropdowns = {},
  accessibePaymodeTemList = [],
  closeForm,
  globalFilter,
  setGlobalFilter,
  searchHandler,
  filterCount,
  setFilterCount,
}) => {
  const [filterForm, setFilterForm] = useState(initialForm);
  const filterFormHandler = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    setFilterForm({
      ...globalFilter,
    });
  }, []);

  const applyFilterHandler = () => {
    const req = {
      paymentMode: filterForm?.paymentMode,
      uploadedBy: filterForm?.uploadedBy,
      status: filterForm?.status,
      fromProcessingDate:
        filterForm?.fromProcessingDate && filterForm?.fromProcessingDate,
      toProcessingDate:
        filterForm?.toProcessingDate && filterForm?.toProcessingDate,
    };
    searchHandler(updateRequest(req));
    let fCount = getFilterCount(filterForm);
    setFilterCount(fCount);
    setGlobalFilter(filterForm);
    closeForm();
  };
  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg mb-2">Filters</div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            label="Payment Mode"
            placeholder="Select to add"
            items={accessibePaymodeTemList}
            currentValue={filterForm?.paymentMode}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler("paymentMode", value);
            }}
            inputKey=""
          />
          <AAutoComplete
            label="Status"
            placeholder="Select to add"
            items={[
              { label: "Completed", value: "COMPLETED" },
              // {label:'Failed', value: 'FAILED'},
              { label: "In-Progress", value: "PROCESSING" },
            ]}
            currentValue={filterForm?.status}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler("status", value);
            }}
            inputKey=""
          />
          <AInput
            label="Uploaded By"
            placeholder="Enter uploaded by"
            
            value={filterForm?.uploadedBy}
            handler={(uploadedBy) => {
              filterFormHandler("uploadedBy", uploadedBy);
            }}
          />
          <div style={{}}>Processing Date</div>
          <div
            className={"d-flex flex justify-content-between"}
            style={{ gap: "4px" }}
          >
            <CustomDatePickerV2
              placeHolder="From"
              maxDate={moment(new Date())}
              value={filterForm?.fromProcessingDate}
              width={"18px"}
              handler={(index, date, keyName) => {
                filterFormHandler("fromProcessingDate", date);
              }}
            />

            <CustomDatePickerV2
              placeHolder="To"
              width={"18px"}
              maxDate={moment(new Date())}
              minDate={filterForm?.fromProcessingDate}
              value={filterForm?.toProcessingDate}
              handler={(index, date, keyName) => {
                filterFormHandler(
                  "toProcessingDate",
                  moment(date).endOf("day")
                );
              }}
              disabled={!filterForm?.fromProcessingDate}
            />
          </div>

          <div
            className={"mt-3 d-flex flex-row-reverse justify-content-between"}
          >
            <AButton
              variant="primary_filled"
              className="w-full ml-0"
              onClick={() => {
                applyFilterHandler();
              }}
              disabled={getFilterCount(filterForm) == 0}
              updatedStyle={filterCount > 0 ? "" : { width: "100%" }}
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={() => {
                  setFilterForm(initialForm);
                  setGlobalFilter(initialForm);
                  searchHandler();
                  setFilterCount(0);
                }}
              >
                Remove filter
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
export default FilterForm;
